module.exports = __webpack_public_path__ + "static/media/OAcquiring-logo.b3aef084.png";